import { Button, CircularProgress, Typography } from "@mui/material";
import { Tools, ToolsContainer, ToolsTitle } from "../../styles";
import { StatusPedidoDescricao } from "../../../../../../enum/StatusPedido";
import { IMarketplace } from "../../../../../../../marketplace/interfaces/IMarketplace";
import { TipoMarketplace } from "../../../../../../../marketplace/enum/TipoMarketplace";

interface ToolsEmTransporteProps {
    quantidadePedidosSelecionados: number;
    loading: boolean;
    atualizarStatus: (status: StatusPedidoDescricao) => void;
    marketplace: IMarketplace;
    abrirCancelamento: () => void;
}

export const ToolsEmTransporte = ({
    atualizarStatus,
    loading,
    quantidadePedidosSelecionados,
    marketplace,
    abrirCancelamento
}: ToolsEmTransporteProps) => {
    return (
        <Tools>
            <ToolsTitle>
                <Typography variant="subtitle1">
                    {quantidadePedidosSelecionados == 1 ? `1 pedido selecionado` : `${quantidadePedidosSelecionados} pedidos selecionados`}
                </Typography>
            </ToolsTitle>
            <ToolsContainer>
                {loading ? (
                    <CircularProgress size={15} />
                ) : (
                    <>
                        <Button 
                            variant="outlined" 
                            disabled={quantidadePedidosSelecionados != 1}
                            onClick={abrirCancelamento}
                        >
                            Cancelar pedido
                        </Button>
                        {marketplace.tipo != TipoMarketplace.IFOOD && (
                            <Button
                                variant="contained"
                                onClick={() => atualizarStatus(StatusPedidoDescricao["Concluído"])}
                            >
                                Concluir pedido(s)
                            </Button>
                        )}
                    </>
                )}
            </ToolsContainer>
        </Tools>
    );
}